import { controls } from "../../controls";

const rp613 = {
  label: "UNITWISE STATEMENT OF SPINING SECTOR",
  pageLabel: "UNITWISE STATEMENT OF SPINING SECTOR",
  starting: true,
  url: "rp613",
  //formActions: { edit: { allow: true }, delete: { allow: true }, audit: { allow: true } },
  pageType: "history", //pageType: "report",
  // formTabs: {
  //   allTabs: [
  //     {
  //       label: "Basic Info",
  //       uid: "create",
  //       style: { fontFamily: "verdana" }
  //     }
  //   ]
  // },
  filter: [

    ...controls.displayText({ tab: "filter", label: "Taluka", width: "col-sm-2" }),
    ...controls.Taluka({ tab: "filter" }),
    ...controls.showData({ tab: "filter", data: "taluka_display", name: "taluka_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "As on Date", star: true, width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", isRequired: true, name: "as_on_date", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-3 " }),

    ...controls.displayText({ tab: "filter", label: "# Records", width: "col-sm-1" }),
    ...controls.perPage({ tab: 'filter' }),
  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "STATEMENT SHOWING LOAN LIMIT OF SPINING SECTOR",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },

    extraRows: {
      fields: [
        "pledgesanction", "pledgeoutstanding",
        "hpsanction", "hpoutstanding",
        "intrsanction", "introutstanding",
        "stloansanction", "stloanoutstanding",
        "mtloansanction", "mtloanoutstanding",
        "mtconsortiumsanction", "mtconsortiumoutstanding",
        "ltloansanction", "ltloanoutstanding",
        "restloansanction", "restloanoutstanding"
      ],
      subtotals: {
        by: "descn",
        displayIn: "descn",
        groupsOnly: false,
        location: "bottom",
      },
      grandtotal: { type: "fixed", displayIn: "descn", val: "Grand Total", count: true },
      // fixedTotals:[{by:"rows",rows:[1,2,3]}]
    },

    displayColumns: [
      {
        Header: "Branch Code",
        accessor: "Brcode",
        width: 70,


      },
      {
        Header: "Name of the Industry",
        accessor: "descn",
        width: 200


      },

      {
        Header: "Pledge Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "pledgesanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "pledgeoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "Hypothication Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "hpsanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "hpoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "Interim Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "intrsanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "introutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "ST Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "stloansanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "stloanoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "MT Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "mtloansanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "mtloanoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "MT Consortium",
        columns: [
          {
            Header: "Limit Section",
            accessor: "mtconsortiumsanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "mtconsortiumoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "LT Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "ltloansanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "ltloanoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "Restructured Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "restloansanction",
            type: "currency"

          },
          {
            Header: "Outstanding",
            accessor: "restloanoutstanding",
            type: "currency"

          }
        ]
      },
      {
        Header: "Total Loan",
        columns: [
          {
            Header: "Limit Section",
            accessor: "total_loan_limit_section",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [
                { source: 'row', field: 'pledgesanction' },
                { source: 'row', field: 'hpsanction' },
                { source: 'row', field: 'intrsanction' },
                { source: 'row', field: 'stloansanction' },
                { source: 'row', field: 'mtloansanction' },
                { source: 'row', field: 'mtconsortiumsanction' },
                { source: 'row', field: 'ltloansanction' },
                { source: 'row', field: 'restloansanction' },
              ], resultVar: 'total'
            }],
            type: "currency"
          },
          {
            Header: "Outstanding",
            accessor: "total_loan_outstanding",
            formula: [{
              f: 'simpleArithmatic', calcType: 'sum', inputs: [
                { source: 'row', field: 'pledgeoutstanding' },
                { source: 'row', field: 'hpoutstanding' },
                { source: 'row', field: 'introutstanding' },
                { source: 'row', field: 'stloanoutstanding' },
                { source: 'row', field: 'mtloanoutstanding' },
                { source: 'row', field: 'mtconsortiumoutstanding' },
                { source: 'row', field: 'ltloanoutstanding' },
                { source: 'row', field: 'restloanoutstanding' },
              ], resultVar: 'total'
            }],
            type: "currency"

          }
        ]
      },
    ]
  }
};

export default rp613;